<template>
  <nav>
    <div class="header-name">
      <p>后端服务管理系统</p>
    </div>
    <div class="header__collapse-icon" @click="$emit('collapse-toggle')">
      <i class="el-icon-menu"></i>
    </div>
    <div class="actions">
      <el-dropdown
        class="user-dropdown"
        trigger="click"
        @command="handleCommand"
      >
        <span class="el-dropdown-link">
          {{ $store.getters.screenName
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="changePWD">修改密码</el-dropdown-item>
          <el-dropdown-item command="logout">登出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </nav>
</template>

<script>
import { LogoutMixin } from "@/mixins";
export default {
  name: "NavBar",
  mixins: [LogoutMixin],
  methods: {
    handleCommand(cmd) {
      switch (cmd) {
        case "logout":
          this.logout();
          break;
        case "changePWD":
          this.$router.push({ name: "change_password" });
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles";
nav {
  height: $nav-height;
  background-color: #54a0ff;
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 10px;
}
.header-name {
  margin-left: 10px;
  p {
    color: white;
    font-size: 1.3rem;
  }
}
.header__collapse-icon {
  color: white;
  font-size: 1.8em;
  margin-left: 10px;
  cursor: pointer;
  display: none;
}
@media screen and (max-width: 768px) {
  .header-name {
    display: none;
  }
  .header__collapse-icon {
    display: block;
  }
}
.actions {
  margin-right: 10px;
  position: absolute;
  right: 0;
}
.user-dropdown {
  color: white;
  cursor: pointer;
}
</style>
